import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import ApproveIcon from '@material-ui/icons/Check';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 500,
  },
  actionsContainer: {
    display: 'flex',
  },
  saveButton: {
    marginRight: theme.spacing(1),
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
}));

interface PageHeaderProps {
  formType: 'ub04' | 'cms1500';
  hasUnsavedChanges: boolean;
  hasForms: boolean;
  onSave: () => void;
  onAddNewForm: () => void;
  isManuallyApproved?: boolean;
}

/**
 * Header component for the Manual Ingest page
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  formType,
  hasUnsavedChanges,
  hasForms,
  isManuallyApproved,
  onSave,
  onAddNewForm,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h4" component="h1" className={classes.title}>
        {formType === 'ub04' ? 'UB04' : 'CMS-1500'} Manual Ingest
      </Typography>
      <Box className={classes.actionsContainer}>
        {hasForms && (
          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
            disabled={!hasUnsavedChanges}
            className={classes.saveButton}
          >
            Save Changes
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onAddNewForm}
          className={classes.addButton}
        >
          Add New Form
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ApproveIcon />}
          onClick={onAddNewForm}
          className={classes.addButton}
          disabled={isManuallyApproved}
        >
          Approve
        </Button>
      </Box>
    </Box>
  );
};

export default PageHeader;
